<mat-dialog-content>
  <div class="modal-header">
    <h4 class="modal-title pull-left pr-10">Add Product Highlight</h4><i class="fas fa-times pull-right fontL3 pl-10" (click)="hideModal()"></i>
  </div>
  <div class="modal-body" style="max-height: 300px; overflow-y: auto;">
    <div class="highlights-section mb-4">
      <h5>Select from existing highlights</h5>
      <div class="flex flex-wrap gap-12 mb-4 col-xs-12">
        <div *ngFor="let productHighlight of productHighlights" 
             class="highlight-item" 
             [class.selected]="selectedHighlightImage === productHighlight.get('image')"
             (click)="selectHighlight(productHighlight)">
          <img style="width: 70px; height: 70px;" [src]="productHighlight.get('image')" alt="productHighlight" />
        </div>
      </div>
    </div>
    
    <div class="upload-section mb-4">
      <h5>Or upload a new image</h5>
      
      <div class="col-xs-12 p-0">
        <div class="mr-2 mb-2 inline posR bdr" *ngFor="let file of imageFiles; let i = index;">
          <img [src]="file" style="width: 70px; height: 70px;"/>
          <i class="fas fa-trash" (click)="removeFile(i)"></i>
        </div>
      </div>
      
      <div class="col-xs-12 p-0">
        <input class="file-input" 
               name="{{name}}" 
               type="file" 
               #file 
               (change)="onFileChange(file.files)" 
               [accept]="accept" 
               id="{{name}}"
               [disabled]="imageFiles.length > 0 || selectedHighlightImage !== null"/>
        <label class="custom-file-upload" 
               for="{{name}}" 
               [class.disabled]="imageFiles.length > 0 || selectedHighlightImage !== null">
          <em class="fa fa-download pr-2"></em>
          <span>Upload File</span>
        </label>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="flex justifyC">
      <button class="btn btn-xs" 
              [disabled]="!selectedHighlightImage && !uploadedImageUrl"
              (click)="createAndsaveProductHighlight()">Select</button>
    </div>
  </div>
</mat-dialog-content>
